var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgEarningsEvent = function SvgEarningsEvent(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 16",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1371_1101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7143 12.6667H16.0476V14H1.38098V12.6667H2.71431V2.66667C2.71431 2.48986 2.78455 2.32029 2.90958 2.19526C3.0346 2.07024 3.20417 2 3.38098 2H10.0476C10.2245 2 10.394 2.07024 10.5191 2.19526C10.6441 2.32029 10.7143 2.48986 10.7143 2.66667V12.6667H12.0476V6H14.0476C14.2245 6 14.394 6.07024 14.5191 6.19526C14.6441 6.32029 14.7143 6.48986 14.7143 6.66667V12.6667ZM5.38098 7.33333V8.66667H8.04765V7.33333H5.38098ZM5.38098 4.66667V6H8.04765V4.66667H5.38098Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1371_1101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(0.714355)"
  })))));
};
export default SvgEarningsEvent;